/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmPovolenySpisovyUzelFunkce extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmPovolenySpisovyUzelFunkceObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmPovolenySpisovyUzelFunkceReadDto[];
        private editData: any[];
        private editMode: boolean;
        private keys: string[];

        onClose() {
            return this.hromadnaOperaceObj.closeOnSuccess;
        }

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmPovolenySpisovyUzelFunkceObj())
            this.hromadnaOperaceObj.createBase({
                title: this.editMode == true ? "jres:33001036" : "jres:33001035", //RC 33001036 : Hromadná úprava dat
                data: this.editMode == true ? this.editData : this.data,
                objectFields: ['ixs_fun_ref_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmPovolenySpisovyUzelFunkce",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmPovolenySpisovyUzelFunkce ",
                editMode: this.editMode,
                updateExist: true,
                formSettings: {
                    aktivitaField: true,
                    datOdDoField: false,
                }
            })
        }
    }

    export class HromadnaOperaceAdmPovolenySpisovyUzelFunkceObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmPovolenySpisovyUzelFunkceReadDto> {
        typ_usr: number
        openFromInstance: boolean;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs_fun",
                    model: "model.ixs_fun=value.ixs_fun;model.ixs_fun_txt<=value.nazev;ixs_ref_txt<=value.nazev_ref",
                    dropdown: true,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33001037").addField("gselectbox", Gordic.Prefabs.Select.admGinspod({ //RC 33001037 : Spisové uzly
                    gridFormat: new Gordic.Data.GridFormat()
                        .addTextColumn({
                            name: "nazev",
                            caption: "jres:32131029"
                        })
                        .addTextColumn({
                            name: "zkratka",
                            caption: "jres:32131028"
                        })
                        .addTextColumn({
                            name: "lic_adr",
                            caption: "jres:29930142"
                        })
                        .addTextColumn({
                            name: "ico",
                            caption: "jres:32131151"
                        })
                }), {  
                    name: "ixs_su",
                    model: "model.ixs_su=value.ixs_su;model.ixs_su_txt<=value.nazev;model.lic_adr<=value.lic_adr",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                }) 
            $("<div>").appendTo(contentDiv).gform("createFrom", this.createDefaultFields(form));
        }

        createDefineGridData(formData: any): any {
            let cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_fun", "ixs_fun_txt", "ixs_ref_txt"]), this.transformDataToArrayObject(formData, ["ixs_su", "ixs_su_txt", "lic_adr"]));
            let resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs_fun: item[0]["ixs_fun"],
                    ixs_fun_txt: item[0]["ixs_fun_txt"],
                    ixs_ref_txt: item[0]["ixs_ref_txt"],
                    ixs_fun_ref_txt: `${item[0]["ixs_fun_txt"]} - ${item[0]["ixs_ref_txt"]}`,
                    ixs_su: item[1]["ixs_su"],
                    ixs_su_txt: item[1]["ixs_su_txt"],
                    lic_adr: item[1]['lic_adr'],
                    aktivita: formData['aktivita'],
                    aktivita_txt: formData['aktivita_txt']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            gridFormat.addTextColumn({
                caption: "jres:29802552",
                name: "ixs_fun_ref_txt",
            }).addTextColumn({
                caption: "jres:29930682",
                name: "ixs_su_txt",
            }).addTextColumn({
                caption: "jres:33001038", //RC 33001038 : Licence spisového uzlu
                name: "lic_adr",
            }).addTextColumn({
                caption: "jres:29924152",
                name: "aktivita_txt",
                editor: {
                    widget: "gselectbox",
                    options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        dropdown: true,
                        model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                        validators: [
                            new Gordic.Validators.Required({ stopping: true })
                        ]
                    })
                }
            })
            return gridFormat;
        }

        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmPovolenySpisovyUzelFunkceSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs_fun: item['ixs_fun'],
                    ixs_su: item['ixs_su'],
                    aktivita: item['aktivita'],
                    NewRecord: false
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return this.cnt.isl.AdmPovolenySpisovyUzelFunkce.isExist({ dtos: data }).get();
        }
    }
}